import {
  SetSalaryPortabilityErrorAction,
  SetSalaryPortabilityFavoredAction,
  SetSalaryPortabilitySuccessAction,
} from '@portal/actions/salaryPortability';

import * as ActionType from '~/actions/actionTypes';

const initialState: reducers.SalaryPortabilityReducer = {
  favored: null,
  error: null,
  success: null,
};

export type SetSalaryPortabilityActions =
  | SetSalaryPortabilityErrorAction
  | SetSalaryPortabilityFavoredAction
  | SetSalaryPortabilitySuccessAction;

const settingsReducer = (
  state = initialState,
  action: SetSalaryPortabilityActions
): reducers.SalaryPortabilityReducer => {
  const { type, payload } = action;
  switch (type) {
    case ActionType.SET_SALARY_PORTABILITY_FAVORED:
      if (payload instanceof Error || typeof payload === 'string') {
        return state;
      }

      return {
        ...state,
        favored: payload,
      };
    case ActionType.SET_SALARY_PORTABILITY_SUCCESS:
      if (typeof payload !== 'string' && payload !== null) {
        return state;
      }

      return {
        ...state,
        success: payload,
      };
    case ActionType.SET_SALARY_PORTABILITY_ERROR:
      if (!(payload instanceof Error) && payload !== null) {
        return state;
      }

      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default settingsReducer;
